import { omit } from 'lodash'

export default (...fields) => async (ctx, next) => {
  await next()
  const { body } = ctx.response
  if (typeof body === 'object' && !Array.isArray(body)) ctx.response.body = omit(body, fields)
}
